import { render, staticRenderFns } from "./ForgetPassportVideo.vue?vue&type=template&id=56287032&scoped=true&"
var script = {}
import style0 from "./ForgetPassportVideo.vue?vue&type=style&index=0&id=56287032&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56287032",
  null
  
)

export default component.exports